import { useParams } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../../../context/AuthContext';
import Swal from 'sweetalert2'
import axios from "axios";
import { API_BASE_URL } from "../../../../../../Helpers/apiConfig";



export const AdminEditSection = () => {
    const { t } = useTranslation()
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const params = useParams();
    const [data, setData] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/TagManager/Update`;
            await axios({
                method: 'Post',
                url: url,
                data: {
                    id: data.id,
                    isDeleted: document.getElementById("isDeleted").value,
                    tagName: document.getElementById("tagName").value,
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            // text: "You clicked the button!",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    }

    useEffect(() => {
        (async () => {
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = `${API_BASE_URL}/admin/TagManager/GetTagById`;
                await axios({
                    method: 'GET',
                    url: url,
                    params: {
                        id: params["id"]
                    },
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        setData(res.data['data'])
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            } catch (err) {
                setMsg(err);
            }

        })()
    }, [])


    return (
        <div style={{ backgroundColor: "white", padding: "3%" }}>
            <div style={{ textAlign: "center" }}>
                <h1>{t("editTag")}</h1>
            </div>
            <h4>{msg}</h4>
            <form onSubmit={handleSubmit} >
                <div class="mb-3">
                    <label for="tagName" class="form-label">{t("tagName")}</label>
                    <textarea class="form-control" id="tagName" defaultValue={data.tagName} required />
                </div>
                <div class="mb-3">
                    <label for="isDeleted" class="form-label">{t('isDeleted')}</label>

                    {data.isDeleted ? (
                        <select id="isDeleted" class="form-select" required >
                            <option key="1" value="true" selected>{t('deleted')}</option>
                            <option key="0" value="false" >{t('active')}</option>
                        </select>

                    ) : (
                        <select id="isDeleted" class="form-select" required >
                            <option key="0" value="false" selected>{t('active')}</option>
                            <option key="1" value="true" >{t('deleted')}</option>
                        </select>
                    )}
                </div>

                <div className='d-flex justify-content-center'>
                    <button type="submit" class="btn btn-primary btn-lg">{t("update")}</button>
                </div>
            </form>
        </div>
    );
};
export default AdminEditSection;
